import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailNote } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailNote";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyVehicleDetailResponseDTO;
};

export const AutoMotoBasicInfoDetails: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	if (!data.description) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.DataCard.BasicInfo.additionalInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={data.description}
				/>
			</Stack>
		</>
	);
};
